import { render, staticRenderFns } from "./MaterialGuideDetail.vue?vue&type=template&id=2dc6a542"
import script from "./MaterialGuideDetail.vue?vue&type=script&lang=js"
export * from "./MaterialGuideDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports